import { render, staticRenderFns } from "./MainBanner.vue?vue&type=template&id=0af64431&scoped=true&"
import script from "./MainBanner.vue?vue&type=script&lang=ts&"
export * from "./MainBanner.vue?vue&type=script&lang=ts&"
import style0 from "./MainBanner.vue?vue&type=style&index=0&id=0af64431&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af64431",
  null
  
)

export default component.exports